import React from 'react';
import Layout from '../components/Layout';
import MobileAboutUsPage from '../components/MobileAboutUsPage';
import useMediaQuery from '../hooks/useMediaQuery';

const AboutUsPage = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Layout>
      {isMobile ? <MobileAboutUsPage /> : (
        <section className="w-full px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 py-8 md:py-12 lg:py-16">
          <div className="max-w-screen-2xl mx-auto">
            <div className="mb-8 md:mb-12 lg:mb-16 text-center overflow-x-auto">
  <h1
    style={{
      fontFamily: 'Bricolage Grotesque',
      fontWeight: 500,
      fontSize: '64px',
      lineHeight: '80px',
      letterSpacing: '-1%',
      whiteSpace: 'nowrap' // Ensures single line
    }}
    className="text-white mx-auto tracking-tight"
  >
    Built By an AI Enthusiast. For AI Founders
  </h1>
</div>


            <div className="w-full max-w-7xl mx-auto">
              <div
                className="relative rounded-2xl overflow-hidden shadow-2xl"
                style={{
                  aspectRatio: '16/9',
                  maxWidth: '1511px',
                  height: 'auto',
                }}
              >
                <iframe
                  className="absolute inset-0 w-full h-full rounded-2xl"
                  src="https://www.youtube.com/embed/6aqnYDehMMk?si=xdNWyYjAl7vPKxUz"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      )}
    </Layout>
  );
};

export default AboutUsPage;